module.exports = __webpack_public_path__ + "assets/img/32_628.380aa8e3.jpg";